// Publisher discovery: runs that find independent articles a startup could earn a link from. A run
// carries itself from step to step once started, and stops for the reader before its searches are
// paid for.
class PublisherDiscovery {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/search-visibility/publisher-discovery-runs`;
    this.apiClient = apiClient;

  }

  async getRuns(paginationOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  // Without pages the run reads the site's top pages from the latest scan.
  async createRun(priorityPageURLs) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, { priorityPageURLs });

  }

  async getRun(publisherDiscoveryRunId) {

    const path = `${this.basePath}/:publisherDiscoveryRunId`;

    return this.apiClient.get(path, { publisherDiscoveryRunId }, {});

  }

  async getQueries(publisherDiscoveryRunId) {

    const path = `${this.basePath}/:publisherDiscoveryRunId/queries`;

    return this.apiClient.get(path, { publisherDiscoveryRunId }, {});

  }

  // Spends credits: every approved query is one paid search.
  async submitSearches(publisherDiscoveryRunId, approvedQueryIds) {

    const path = `${this.basePath}/:publisherDiscoveryRunId/searches`;

    return this.apiClient.post(path, { publisherDiscoveryRunId }, {}, { mode: 'live_search', approvedQueryIds });

  }

  async getOpportunities(publisherDiscoveryRunId, paginationOptions) {

    const path = `${this.basePath}/:publisherDiscoveryRunId/opportunities`;

    return this.apiClient.get(path, { publisherDiscoveryRunId }, { paginationOptions });

  }

}

export default PublisherDiscovery;
